import html2canvas from 'html2canvas';
import { jsPDF as JSPDF } from 'jspdf';
import ReactDOMServer from 'react-dom/server';
import { GenerateRowSets, RenderPage } from './pdfTableHelpers';
import { PdfData } from '@/models';

const PAGE_HEIGHT = 210;
const TERMS_AND_CONDITIONS_LINK = 'https://docs.google.com/document/d/1C7UG-qkDWM7MTxK1W4-y1rwuqZ3JLoyC';
const normalizeFileName = (fileName: string): string => {
  const regexp = /^[@#$%^&\\\-_ +=<>()/'"!*,.?;:]+$/;
  const normalized = fileName.split('').map((char) => (regexp.test(char) ? '' : char));

  return normalized.join('');
};

const setFooter = (doc: JSPDF) => {
  const text = 'Terms and Conditions';

  const fontSize = 8;
  doc.setFontSize(8);
  doc.setTextColor(11, 22, 117);
  const textWidth = (doc.getStringUnitWidth(text) * fontSize) / doc.internal.scaleFactor;

  const footerTextY = PAGE_HEIGHT - 11;
  const footerTextX = 68;
  doc.textWithLink(text, footerTextX, footerTextY, { url: TERMS_AND_CONDITIONS_LINK });
  doc.setDrawColor(11, 22, 117);
  doc.setLineWidth(0.2);
  doc.line(footerTextX, footerTextY + 1, footerTextX + textWidth + 1, footerTextY + 1);
};

const buildPage = async (doc: JSPDF, pdfData: PdfData): Promise<void> => {
  const iframe = document.createElement('iframe');
  iframe.style.visibility = 'hidden';

  document.body.appendChild(iframe);
  const iframeDoc = iframe?.contentDocument || iframe.contentWindow?.document;
  if (!iframeDoc?.body) return;

  const pages = GenerateRowSets(pdfData);

  if (pages.length === 0) {
    iframe.remove();
    return;
  }

  for (let index = 0; index < pages.length; index++) {
    const pageItem = pages[index];
    iframeDoc.body.innerHTML = ReactDOMServer.renderToString(
      RenderPage({ ...pdfData, rows: pageItem, addFooter: index === pages.length - 1 })
    );
    const canvas = await html2canvas(iframeDoc.body);
    const imageData = canvas.toDataURL('image/jpeg');
    const width = 297;
    const height = (canvas.height * width) / canvas.width;

    doc.addImage({ imageData, x: 0, y: 0, width, height, format: 'JPEG', compression: 'MEDIUM' });
    if (index < pages.length - 1) {
      doc.addPage();
    }
  }
};

export const buildPDF = async (fileName: string, pdfData: PdfData): Promise<void> => {
  const doc = new JSPDF('l', 'mm');
  await buildPage(doc, pdfData);
  setFooter(doc);
  const safeName = normalizeFileName(fileName) || 'campaign-schedule';
  doc.save(`${safeName}.pdf`);
};
